import React, { Component } from 'react'
import { get } from '../../../utils/networking'
import $ from 'jquery'

export default class ContactUs extends Component {
    constructor(props) {
        super(props)

        this.state = {
            content: ""
        }
    }

    componentWillMount() {
        get('page/contact-us', "", result => {
            this.setState({
                content: result.content
            })
        })
    }

    render() {
        let {
            content
        } = this.state;
        return (
            <div id="partnerfaqs_aboutus" className='panel'>
                <div dangerouslySetInnerHTML={{ __html: content }} className="text"></div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/partnerfaqs/contactUs/index.js